import 'core-js';
import 'regenerator-runtime/runtime';
import React from 'react';
import { render } from 'react-dom';
import Root from './components/application-shell/Root/Root';
import configureStore from './store/configureStore';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import initDatadog from './helpers/initDatadog';

import './styles/global.scss';

const store = configureStore();
initDatadog();

render(
  <ErrorBoundary>
    <Root
      store={store}
    />
  </ErrorBoundary>,
  document.getElementById('root'),
);
